var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"main-category"},[_c(_setup.MainCategoryHeader,{attrs:{"title":_setup.mainTitle,"options":_setup.subCategoryList.itemList,"default":'장르'},on:{"on-click-back":_setup.goToBack}}),_c(_setup.WCatalog,{staticClass:"home-catalog",attrs:{"catalog":_setup.catalogData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }